import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive } from 'vue';
import PackageSelector from './BookingComponents/PackageSelector.vue';
import ServiceSelector from './BookingComponents/ServiceSelector.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentCreate',
  setup(__props) {

const state = reactive({
    tab: 'service'
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: state.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "service" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Service", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "package" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Package", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: state.tab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.tab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "service" }, {
                default: _withCtx(() => [
                  _createVNode(ServiceSelector)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "package" }, {
                default: _withCtx(() => [
                  _createVNode(PackageSelector)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})